<template>
  <div class="step-thank-you">
    <img
      src="/images/satisfaction-survey/thank-you.png"
      class="step-thank-you__image"
      alt="high-five illustration"
    />
    <div class="step-thank-you__content">
      <h3 class="step-thank-you__header">
        Thank you for your valuable time and insights!
      </h3>
      <p class="step-thank-you__text">
        Your feedback has been sent to our team and will help us improve our
        services.
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.step-thank-you {
  display: flex;
  flex-direction: column;
  gap: 56px;

  @media (min-width: $breakpoint-lg) {
    flex-direction: row;
  }

  &__image {
    width: 100%;
    max-width: 120px;

    @media (min-width: $breakpoint-lg) {
      max-width: 150px;
    }
  }

  &__header {
    margin-bottom: 12px;
  }

  &__text {
    margin-bottom: 0;
  }

  &__content {
    @media (min-width: $breakpoint-lg) {
      padding-top: 30px;
    }
  }
}
</style>
